// useDirectionByLanguage.js

import { useState, useEffect } from 'react';

export function useDirectionByLanguage(i18n) {
  const [direction, setDirection] = useState('ltr');

  useEffect(() => {
    if (i18n.language === 'he' || i18n.language === 'ar') {
      setDirection('rtl');
    } else {
      setDirection('ltr');
    }
  }, [i18n.language]);

  return direction;
}

